import React, { Component } from "react";
import HomeLine from "./HomeLine";
import { isMobile } from "react-device-detect";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import { Collapse } from "reactstrap";

export default class HomeFAQ extends Component {
    constructor(props) {
        super(props);

        const t = props.t;
        this.state = {
            items: [{
                title: t('homeProject.faq.h1'),
                text: t('homeProject.faq.t1'),
                isOpen: false
            }, {
                title: t('homeProject.faq.h2'),
                text: t('homeProject.faq.t2'),
                isOpen: false
            }, {
                title: t('homeProject.faq.h3'),
                text: t('homeProject.faq.t3'),
                isOpen: false
            }, {
                title: t('homeProject.faq.h4'),
                text: t('homeProject.faq.t4'),
                isOpen: false
            }, {
                title: t('homeProject.faq.h5'),
                text: t('homeProject.faq.t5'),
                isOpen: false
            }]
        };
    }

    toggleOpen = (index) => {
        let items = [...this.state.items];
        items[index] = {
            ...items[index],
            isOpen: !items[index].isOpen
        };
        this.setState({ items });
    }

    render() {
        return (
            <div style={{ marginBottom: "50px" }}>
                <div className="align-center mb-3">
                    <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>FAQ</b></div>
                    <HomeLine className="self-center" />
                </div>
                {this.state.items.map((item, index) => (
                    <div key={index} className="mb-2">
                        <div
                            className="hf-header"
                            style={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                            onClick={() => this.toggleOpen(index)}
                        >
                            {item.isOpen ?
                                <IoMdArrowDropdown size="1.8em" color="black" />
                                :
                                <IoMdArrowDropright size="1.8em" color="black" />
                            }
                            <span className="hf-title">{item.title}</span>
                        </div>
                        <Collapse isOpen={item.isOpen} className="hf-content">
                            {item.text}
                        </Collapse>
                    </div>
                ))}
            </div>
        );
    }
}